import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { Provider } from "react-redux";
import { legacy_createStore as createStore } from "redux";
import appReducer from "./redux/appReducer";
import Head from "./Head";
import { Config } from "./config/IISMethods";
import { BrowserRouter } from "react-router-dom";

import "./Css";

const root = ReactDOM.createRoot(document.getElementById("root"));

if (Config.getServermode() === 'prod') { // Bhautik 22-06-2023 03:04 PM ~ for remove all console on server
    // console.log = console.warn = console.error = () => {}
    // console.log = () => {}
}

export const store = createStore(
    appReducer,
    window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
);

root.render(
    <Provider store={store}>
        <BrowserRouter>
            <Head />
            <App />
        </BrowserRouter>
    </Provider>
);